import { useState } from 'react';
import Layout from '../components/Layout';
import { blogPosts } from '../data/blog-posts';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { BookOpen, Search } from 'lucide-react';
import RoadmapTimeline from '../components/RoadmapTimeline';

const Blog = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const featuredPost = blogPosts[0];

  const filteredPosts = blogPosts.filter(post => {
    const searchLower = searchTerm.toLowerCase();
    return (
      post.title.toLowerCase().includes(searchLower) ||
      post.excerpt.toLowerCase().includes(searchLower) ||
      post.content.toLowerCase().includes(searchLower) ||
      post.tags.some(tag => tag.toLowerCase().includes(searchLower))
    );
  });

  return (
    <Layout>
      <section className="py-20">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 dark:text-white">Fembot Blog</h1>
            <p className="text-gray-600 dark:text-gray-300 max-w-2xl mx-auto mb-8">
              Discover the latest updates, guides, and best practices for making the most of Fembot.
            </p>
            <div className="max-w-md mx-auto">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500" />
                <Input
                  type="text"
                  placeholder="Search by title or tags..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-10"
                />
              </div>
            </div>
          </div>

          {!searchTerm && (
            <div className="mb-12">
              <h2 className="text-2xl font-bold mb-6 dark:text-white">Featured Post</h2>
              <Card className="card-hover">
                <div className="md:flex">
                  <div className="relative h-64 md:h-auto md:w-1/2">
                    <img 
                      src={featuredPost.imageUrl || "/placeholder2.svg"} 
                      alt={featuredPost.title}
                      className="w-full h-full object-cover rounded-t-lg md:rounded-l-lg md:rounded-tr-none"
                    />
                  </div>
                  <div className="md:w-1/2 p-6">
                    <div className="flex items-center text-sm text-gray-500 dark:text-gray-400 mb-2">
                      <span>{featuredPost.date}</span>
                      <span className="mx-2">•</span>
                      <div className="flex items-center">
                        <BookOpen className="h-4 w-4 mr-1" />
                        <span>{featuredPost.readTime}</span>
                      </div>
                    </div>
                    <Link 
                      to={`/blog/${featuredPost.id}`}
                      className="text-2xl font-bold hover:text-fembot-pink transition-colors block mb-4"
                    >
                      {featuredPost.title}
                    </Link>
                    <p className="text-gray-600 dark:text-gray-300 mb-4">
                      {featuredPost.excerpt}
                    </p>
                    <div className="flex flex-wrap gap-2">
                      {featuredPost.tags.map((tag) => (
                        <span 
                          key={tag}
                          className="inline-block px-3 py-1 text-sm font-medium bg-pink-100 text-fembot-pink rounded-full dark:bg-pink-900/30"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </Card>
            </div>
          )}

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {filteredPosts
              .filter(post => !searchTerm || post.id !== featuredPost.id)
              .map((post) => (
                <Card key={post.id} className="card-hover">
                  <div className="relative h-48 overflow-hidden rounded-t-lg">
                    <img 
                      src={post.imageUrl || "/placeholder2.svg"} 
                      alt={post.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <CardHeader>
                    <div className="flex items-center justify-between text-sm text-gray-500 dark:text-gray-400 mb-2">
                      <span>{post.date}</span>
                      <div className="flex items-center">
                        <BookOpen className="h-4 w-4 mr-1" />
                        <span>{post.readTime}</span>
                      </div>
                    </div>
                    <CardTitle className="line-clamp-2">
                      <Link 
                        to={`/blog/${post.id}`}
                        className="text-xl font-bold hover:text-fembot-pink transition-colors"
                      >
                        {post.title}
                      </Link>
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-gray-600 dark:text-gray-300 line-clamp-3 mb-4">
                      {post.excerpt}
                    </p>
                    <div className="flex flex-wrap gap-2">
                      {post.tags.map((tag) => (
                        <span 
                          key={tag}
                          className="inline-block px-2 py-1 text-xs font-medium bg-pink-100 text-fembot-pink rounded-full dark:bg-pink-900/30"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </CardContent>
                </Card>
            ))}
          </div>

          {!searchTerm && (
            <div className="mt-32 mb-20">
              <h2 className="text-2xl font-bold mb-16 dark:text-white text-center">Development Roadmap</h2>
              <div className="max-w-6xl mx-auto">
                <RoadmapTimeline />
              </div>
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
};

export default Blog;
